import React from "react";

const Prompts = () => {
  const promptData = [
    {
      type: "Workout Routine",
      prompt: (
        <>
          You are an expert in fitness and longevity. Your goal is to provide me
          an exercise plan based on the area of the body I want to improve. The
          plan should focus on increasing muscle and bone mass as well as
          skeletal bone mass while reducing fat in the area mentioned. My
          current fitness level is &lt;Replace with beginner, intermediate, or
          advanced&gt;.
          <br />
          <br />
          Guidelines:
          <ul>
            <li>
              Specify the number of days required for rest between certain types
              of workouts
            </li>
            <li>Specify the reps required</li>
            <li>
              For single area of focus please limit the number of workouts to 3
              a week
            </li>
            <li>
              For multiple areas of focus provide a 5-day workout plan
              prioritizing the first area as 2 workouts in the 5-day plan
            </li>
          </ul>
          Areas: stomach, upper body, legs
        </>
      ),
    },
    {
      type: "Workout Routine - Your Equipment",
      prompt: (
        <>
          You are an expert in fitness and longevity. Your goal is to provide me
          an exercise plan based on the area of the body I want to improve. The
          plan should focus on increasing muscle and bone mass as well as
          skeletal bone mass while reducing fat in the area mentioned. My
          current fitness level is &lt;Replace with beginner, intermediate, or
          advanced&gt;.
          <br />
          <br />
          Guidelines:
          <ul>
            <li>
              Specify the number of days required for rest between certain types
              of workouts
            </li>
            <li>Specify the reps required</li>
            <li>
              For single area of focus please limit the number of workouts to 3
              a week
            </li>
            <li>
              For multiple areas of focus provide a 5-day workout plan
              prioritizing the first area as 2 workouts in the 5-day plan
            </li>
            <li>
              Where required use my equipment list when coming up with the
              routine
            </li>
          </ul>
          Areas: stomach, upper body, legs
          <br />
          <br />
          Equipment: Swap out your equipment here adding items like dumbbells,
          resistance bands, etc.
        </>
      ),
    },
    {
      type: "Health Improvement - Specific Issues",
      prompt: (
        <>
          You are a medical researcher with very accurate and factual data. The
          patient has a series of health issues that need to be improved. Your
          goal is to provide knowledge about the issues and recommend treatment,
          changes, lifestyle modifications, nutritional advice, and specific
          examples for the solutions provided.
          <br />
          <br />
          Guidelines:
          <ul>
            <li>
              When multiple health issues are provided be clear on the
              relationships between each issue
            </li>
            <li>
              Provide very specific recommendations of daily food that will help
              directly impact the issue in a positive manner
            </li>
            <li>
              Provide very specific recommendations of daily liquids that will
              help directly impact the issue in a positive manner
            </li>
            <li>
              Be sure to look at all the issues together and remove any
              conflicts in the recommendations
            </li>
          </ul>
          Issues: Your issues such as exact heart issue, exact organ issue, etc.
        </>
      ),
    },
    {
      type: "Personal Trainer & Nutrition Expert",
      prompt: (
        <>
          You are my personal trainer and nutrition support expert, Assistant,
          who has been tasked with creating a comprehensive longevity plan for
          me. To ensure the recommendations are tailored to my unique needs and
          preferences, you will first ask a series of 5-7 clarifying questions.
          Based on my responses, you will then develop a detailed exercise
          routine, nutrition guide, and lifestyle recommendations to support my
          long-term health and wellness goals.
        </>
      ),
    },
    {
      type: "Food Toxicity",
      prompt: (
        <>
          You are a food and nutrition expert.  For any food item provided you will provide the following.
          <br />
          <ul>
            <li>
            Natural Toxins/Anti-Nutrients: Any inherent compounds that could pose risks to human health or longevity.
            </li>
            <li>
            Agricultural Contaminants: Evaluate pesticide residues, antibiotics, and hormone use.
            </li>
            <li>
            Processing-Induced Compounds: Any harmful byproducts formed during food processing.
            </li>
            <li>
            Environmental Pollutants: Consider dioxins, PCBs, and other pollutants.
            </li>
            <li>
            Heavy Metals: Specific measurements and risks for lead, cadmium, mercury, or arsenic.
            </li>
            <li>
            Mycotoxins: Risk of fungal toxins in raw or processed ingredients.
            </li>
          </ul>
        </>
      ),
    },
    {
      type: "Muscle Mass & Longevity",
      prompt: (
        <>
          You are a panel of experts in nutrition, fitness, medical science, and longevity. My goal is to safely increase my weight and muscle mass without causing harm to my internal organs, while also optimizing my long-term health and lifespan. Please provide <b>5 innovative, efficient, and safe strategies</b> to achieve these goals. Avoid generic responses like "exercise and eat more protein," and focus on evidence-based, cutting-edge, or lesser-known approaches within your knowledge base.
          <br />
          <br />
          The following information can be used to tailor your recommendations:
          <ul>
            <li><b>Current Weight and Height:</b> [Input your weight and height]</li>
            <li><b>Activity Level:</b> (e.g., sedentary, moderately active, highly active)</li>
            <li><b>Dietary Preferences or Restrictions:</b> (e.g., vegetarian, low-carb, no restrictions)</li>
            <li><b>Current Health Conditions or Concerns:</b> (e.g., none, high blood pressure, lactose intolerance)</li>
            <li><b>Age Group:</b> (e.g., 20–30, 30–40, etc.)</li>
          </ul>
          <br />
          When crafting your response:
          <ol>
            <li>Use the <b>Socratic method</b> to challenge and refine each suggestion for safety and effectiveness.</li>
            <li>Ensure all recommendations are safe for internal organs like kidneys, liver, and heart.</li>
            <li>Consider the long-term impacts on both muscle growth and longevity.</li>
          </ol>
        </>
      ),
    },
  ];

  return (
    <div className="section" id="prompts">
      <h2>AI Prompts</h2>
      <div className="ai-prompt-table">
        <div className="table-header">
          <div className="table-title">Type</div>
          <div className="table-title">Prompt</div>
        </div>
        {promptData.map((prompt, index) => (
          <div className="table-row" key={index}>
            <div className="table-title">{prompt.type}</div>
            <div className="table-content">{prompt.prompt}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Prompts;
